module.exports = __webpack_public_path__ + "static/media/car-small.7ed3c335.jpg";